import { baseBUCGet } from '../base/baseBUC';

const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const taxModelGet = ({ buildingId = '', userId = '', }) => {
    return {
        date: dateTimeStr,
        percentage: decimal,
        remark: str,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    };
};